export default "__VITE_ASSET__BaZvh60H__"